/*
 * La Médaille Française - Product Page Enhancements
 */

(function () {
  // Metal weight variant update
  function initMetalWeightUpdate() {
    const productSections = document.querySelectorAll(
      '[data-section-type="product-template"], [data-section-type="featured-product"]'
    );

    for (const section of productSections) {
      section.addEventListener('theme:variant:change', function (event) {
        const variant = event.detail.variant;
        const weightBlock = section.querySelector('[data-metal-weight-block]');

        if (!weightBlock) return;

        const weightValueEl = weightBlock.querySelector(
          '[data-metal-weight-value]'
        );

        // Get variant weights from Liquid-generated JSON
        const variantWeights = JSON.parse(
          weightBlock.dataset.variantWeights || '{}'
        );
        const weight = variant ? variantWeights[variant.id] : 0;

        if (weight && weight.length > 0) {
          weightValueEl.textContent = weight;
          weightBlock.classList.remove('hidden');
        } else {
          weightBlock.classList.add('hidden');
        }
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMetalWeightUpdate();
    });
  } else {
    initMetalWeightUpdate();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function () {
    initMetalWeightUpdate();
  });
})();
